import { render } from "./ContactsView.vue?vue&type=template&id=6f0e64df&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"

import "./ContactsView.vue?vue&type=style&index=0&id=6f0e64df&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f0e64df"

export default script